import ReactGA from "react-ga4";

export const initGA = (trackingId: string) => {
    if (process.env.NODE_ENV === 'production') {
      ReactGA.initialize(trackingId);
    }
  };
  
  export const logPageView = () => {
    if (process.env.NODE_ENV === 'production') {
      ReactGA.send({ hitType: 'pageview', page: window.location.pathname });
    }
  };
  